enum ConnectorName {
  microsoft = 'microsoft',
  jira = 'jira',
  linear = 'linear',
}

interface ConnectorInfo {
  id: ConnectorName
  name: string
  logoPath: string
  disconnectDescription?: string
}

const CONNECTORS_PATH = '/images/connectors'

export const CONNECTORS: Record<ConnectorName, ConnectorInfo> = {
  [ConnectorName.microsoft]: {
    id: ConnectorName.microsoft,
    name: 'Microsoft 365',
    logoPath: `${CONNECTORS_PATH}/microsoft-365.svg`,
    disconnectDescription:
      'You won’t be able to add documents from OneDrive or SharePoint until you reconnect. Documents already added stay where they are.',
  },
  [ConnectorName.jira]: {
    id: ConnectorName.jira,
    name: 'Jira',
    logoPath: `${CONNECTORS_PATH}/jira.svg`,
  },
  [ConnectorName.linear]: {
    id: ConnectorName.linear,
    name: 'Linear',
    logoPath: `${CONNECTORS_PATH}/linear.webp`,
  },
}
